module.exports = __webpack_public_path__ + "img/Gallery_3_17.1fe40255.jpeg";